import { Component } from '../core/Component';

/**
 * Animation states for sprite animation
 */
export enum AnimationState {
  Idle = 'idle',
  Moving = 'moving',
  Chomping = 'chomping',
  Frightened = 'frightened',
  Dead = 'dead',
  Spawning = 'spawning',
}

/**
 * Animation component for sprite-based animations
 * Pure data component for managing animation state and timing
 */
export class AnimationComponent extends Component {
  public currentState: AnimationState;
  public currentFrame: number;
  public frameTime: number;
  public animationSpeed: number;
  public loop: boolean;
  public animations: Map<AnimationState, string[]>; // Maps states to texture names
  public isPlaying: boolean;

  constructor(
    initialState: AnimationState = AnimationState.Idle,
    animationSpeed: number = 0.1,
    loop: boolean = true
  ) {
    super();
    this.currentState = initialState;
    this.currentFrame = 0;
    this.frameTime = 0;
    this.animationSpeed = animationSpeed;
    this.loop = loop;
    this.animations = new Map();
    this.isPlaying = true;
  }

  /**
   * Add an animation sequence
   */
  public addAnimation(state: AnimationState, textureNames: string[]): void {
    this.animations.set(state, textureNames);
  }

  /**
   * Get current texture name
   */
  public getCurrentTexture(): string | undefined {
    const textures = this.animations.get(this.currentState);
    if (!textures || textures.length === 0) return undefined;
    return textures[this.currentFrame] || textures[0];
  }

  public clone(): AnimationComponent {
    const clone = new AnimationComponent(
      this.currentState,
      this.animationSpeed,
      this.loop
    );
    clone.currentFrame = this.currentFrame;
    clone.frameTime = this.frameTime;
    clone.isPlaying = this.isPlaying;

    // Deep copy animations map
    for (const [state, textures] of this.animations) {
      clone.animations.set(state, [...textures]);
    }

    return clone;
  }
}
